import { render, staticRenderFns } from "./Homenew.vue?vue&type=template&id=d6c703b4&scoped=true&"
import script from "./Homenew.vue?vue&type=script&lang=js&"
export * from "./Homenew.vue?vue&type=script&lang=js&"
import style0 from "./Homenew.vue?vue&type=style&index=0&id=d6c703b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c703b4",
  null
  
)

export default component.exports